import { cn } from "@/lib/utils";
import { useLanguage } from "@/hooks/useLanguage";
interface PricingToggleProps { isYearly: boolean; onToggle: (yearly: boolean) => void; }
const PricingToggle = ({ isYearly, onToggle }: PricingToggleProps) => {
  const { t } = useLanguage();
  return (
    <div className="flex items-center justify-center gap-4 mb-10">
      <span className={cn("text-sm font-medium transition-colors cursor-pointer", !isYearly ? "text-foreground" : "text-muted-foreground")} onClick={() => onToggle(false)}>{t("pricing.toggle.monthly")}</span>
      <button onClick={() => onToggle(!isYearly)} className={cn("relative w-14 h-7 rounded-full transition-colors", isYearly ? "bg-chathero-mint" : "bg-muted")}><span className={cn("absolute top-1 left-1 w-5 h-5 rounded-full bg-white shadow-sm transition-transform", isYearly ? "translate-x-7" : "translate-x-0")} /></button>
      <div className="flex items-center gap-2">
        <span className={cn("text-sm font-medium transition-colors cursor-pointer", isYearly ? "text-foreground" : "text-muted-foreground")} onClick={() => onToggle(true)}>{t("pricing.toggle.yearly")}</span>
        <span className="bg-chathero-mint/20 text-chathero-mint text-xs font-semibold px-2.5 py-1 rounded-full">{t("pricing.toggle.save")}</span>
      </div>
    </div>
  );
};
export default PricingToggle;
